// source: nockchain/public/v2/nockchain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var nockchain_common_v1_blockchain_pb = require('../../../nockchain/common/v1/blockchain_pb.js');
goog.object.extend(proto, nockchain_common_v1_blockchain_pb);
var nockchain_common_v1_pagination_pb = require('../../../nockchain/common/v1/pagination_pb.js');
goog.object.extend(proto, nockchain_common_v1_pagination_pb);
var nockchain_common_v1_primitives_pb = require('../../../nockchain/common/v1/primitives_pb.js');
goog.object.extend(proto, nockchain_common_v1_primitives_pb);
var nockchain_common_v2_blockchain_pb = require('../../../nockchain/common/v2/blockchain_pb.js');
goog.object.extend(proto, nockchain_common_v2_blockchain_pb);
goog.exportSymbol('proto.nockchain.public.v2.BigNum', null, global);
goog.exportSymbol('proto.nockchain.public.v2.BlockDetails', null, global);
goog.exportSymbol('proto.nockchain.public.v2.BlockEntry', null, global);
goog.exportSymbol('proto.nockchain.public.v2.BlocksData', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplit', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplit.VersionCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplitV0', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplitV0Entry', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplitV1', null, global);
goog.exportSymbol('proto.nockchain.public.v2.CoinbaseSplitV1Entry', null, global);
goog.exportSymbol('proto.nockchain.public.v2.ExplorerMetrics', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlockDetailsRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlockDetailsRequest.SelectorCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlockDetailsResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlockDetailsResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlocksRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlocksResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetBlocksResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetExplorerMetricsRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetExplorerMetricsResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetExplorerMetricsResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionBlockRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionBlockResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionBlockResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionDetailsRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionDetailsResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.GetTransactionDetailsResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.PageMsg', null, global);
goog.exportSymbol('proto.nockchain.public.v2.ProofOfWork', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionAcceptedRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionAcceptedResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionAcceptedResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionBlockData', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionDetails', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionDetails.FeeRequiredCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionDetails.TotalOutputRequiredCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionInput', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionOutput', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionOutput.AmountRequiredCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.TransactionPending', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletGetBalanceRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletGetBalanceRequest.SelectorCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletGetBalanceResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletGetBalanceResponse.ResultCase', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletSendTransactionRequest', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletSendTransactionResponse', null, global);
goog.exportSymbol('proto.nockchain.public.v2.WalletSendTransactionResponse.ResultCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.WalletGetBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.WalletGetBalanceRequest.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.WalletGetBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.WalletGetBalanceRequest.displayName = 'proto.nockchain.public.v2.WalletGetBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.WalletGetBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.WalletGetBalanceResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.WalletGetBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.WalletGetBalanceResponse.displayName = 'proto.nockchain.public.v2.WalletGetBalanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.WalletSendTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.WalletSendTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.WalletSendTransactionRequest.displayName = 'proto.nockchain.public.v2.WalletSendTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.WalletSendTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.WalletSendTransactionResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.WalletSendTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.WalletSendTransactionResponse.displayName = 'proto.nockchain.public.v2.WalletSendTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionAcceptedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.TransactionAcceptedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionAcceptedRequest.displayName = 'proto.nockchain.public.v2.TransactionAcceptedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionAcceptedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.TransactionAcceptedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionAcceptedResponse.displayName = 'proto.nockchain.public.v2.TransactionAcceptedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetBlocksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.GetBlocksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetBlocksRequest.displayName = 'proto.nockchain.public.v2.GetBlocksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetBlocksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetBlocksResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetBlocksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetBlocksResponse.displayName = 'proto.nockchain.public.v2.GetBlocksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.BlocksData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.BlocksData.repeatedFields_, null);
};
goog.inherits(proto.nockchain.public.v2.BlocksData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.BlocksData.displayName = 'proto.nockchain.public.v2.BlocksData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.BlockEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.BlockEntry.repeatedFields_, null);
};
goog.inherits(proto.nockchain.public.v2.BlockEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.BlockEntry.displayName = 'proto.nockchain.public.v2.BlockEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetTransactionBlockRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.GetTransactionBlockRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetTransactionBlockRequest.displayName = 'proto.nockchain.public.v2.GetTransactionBlockRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetTransactionBlockResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetTransactionBlockResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetTransactionBlockResponse.displayName = 'proto.nockchain.public.v2.GetTransactionBlockResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionBlockData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.TransactionBlockData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionBlockData.displayName = 'proto.nockchain.public.v2.TransactionBlockData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionPending = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.TransactionPending, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionPending.displayName = 'proto.nockchain.public.v2.TransactionPending';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.GetTransactionDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetTransactionDetailsRequest.displayName = 'proto.nockchain.public.v2.GetTransactionDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetTransactionDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetTransactionDetailsResponse.displayName = 'proto.nockchain.public.v2.GetTransactionDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.TransactionDetails.repeatedFields_, proto.nockchain.public.v2.TransactionDetails.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.TransactionDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionDetails.displayName = 'proto.nockchain.public.v2.TransactionDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.TransactionInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionInput.displayName = 'proto.nockchain.public.v2.TransactionInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.TransactionOutput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.TransactionOutput.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.TransactionOutput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.TransactionOutput.displayName = 'proto.nockchain.public.v2.TransactionOutput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetBlockDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetBlockDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetBlockDetailsRequest.displayName = 'proto.nockchain.public.v2.GetBlockDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetBlockDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetBlockDetailsResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetBlockDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetBlockDetailsResponse.displayName = 'proto.nockchain.public.v2.GetBlockDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.GetExplorerMetricsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetExplorerMetricsRequest.displayName = 'proto.nockchain.public.v2.GetExplorerMetricsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.GetExplorerMetricsResponse.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.GetExplorerMetricsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.GetExplorerMetricsResponse.displayName = 'proto.nockchain.public.v2.GetExplorerMetricsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.ExplorerMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.ExplorerMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.ExplorerMetrics.displayName = 'proto.nockchain.public.v2.ExplorerMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.BlockDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.BlockDetails.repeatedFields_, null);
};
goog.inherits(proto.nockchain.public.v2.BlockDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.BlockDetails.displayName = 'proto.nockchain.public.v2.BlockDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.ProofOfWork = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.ProofOfWork, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.ProofOfWork.displayName = 'proto.nockchain.public.v2.ProofOfWork';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.BigNum = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.BigNum, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.BigNum.displayName = 'proto.nockchain.public.v2.BigNum';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.CoinbaseSplit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.public.v2.CoinbaseSplit.oneofGroups_);
};
goog.inherits(proto.nockchain.public.v2.CoinbaseSplit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.CoinbaseSplit.displayName = 'proto.nockchain.public.v2.CoinbaseSplit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.CoinbaseSplitV0 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.CoinbaseSplitV0.repeatedFields_, null);
};
goog.inherits(proto.nockchain.public.v2.CoinbaseSplitV0, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.CoinbaseSplitV0.displayName = 'proto.nockchain.public.v2.CoinbaseSplitV0';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.CoinbaseSplitV0Entry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.CoinbaseSplitV0Entry.displayName = 'proto.nockchain.public.v2.CoinbaseSplitV0Entry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.CoinbaseSplitV1 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.public.v2.CoinbaseSplitV1.repeatedFields_, null);
};
goog.inherits(proto.nockchain.public.v2.CoinbaseSplitV1, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.CoinbaseSplitV1.displayName = 'proto.nockchain.public.v2.CoinbaseSplitV1';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.CoinbaseSplitV1Entry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.CoinbaseSplitV1Entry.displayName = 'proto.nockchain.public.v2.CoinbaseSplitV1Entry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.public.v2.PageMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.public.v2.PageMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.public.v2.PageMsg.displayName = 'proto.nockchain.public.v2.PageMsg';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.SelectorCase = {
  SELECTOR_NOT_SET: 0,
  ADDRESS: 1,
  FIRST_NAME: 2
};

/**
 * @return {proto.nockchain.public.v2.WalletGetBalanceRequest.SelectorCase}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.getSelectorCase = function() {
  return /** @type {proto.nockchain.public.v2.WalletGetBalanceRequest.SelectorCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.WalletGetBalanceRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.WalletGetBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.WalletGetBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
address: (f = msg.getAddress()) && nockchain_common_v1_primitives_pb.Base58Pubkey.toObject(includeInstance, f),
firstName: (f = msg.getFirstName()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f),
page: (f = msg.getPage()) && nockchain_common_v1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.WalletGetBalanceRequest;
  return proto.nockchain.public.v2.WalletGetBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.WalletGetBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Pubkey;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Pubkey.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setFirstName(value);
      break;
    case 3:
      var value = new nockchain_common_v1_pagination_pb.PageRequest;
      reader.readMessage(value,nockchain_common_v1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.WalletGetBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.WalletGetBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Pubkey.serializeBinaryToWriter
    );
  }
  f = message.getFirstName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Pubkey address = 1;
 * @return {?proto.nockchain.common.v1.Base58Pubkey}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.getAddress = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Pubkey} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Pubkey, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Pubkey|undefined} value
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
*/
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.setAddress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.WalletGetBalanceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Base58Hash first_name = 2;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.getFirstName = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
*/
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.WalletGetBalanceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.clearFirstName = function() {
  return this.setFirstName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.hasFirstName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.PageRequest page = 3;
 * @return {?proto.nockchain.common.v1.PageRequest}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.getPage = function() {
  return /** @type{?proto.nockchain.common.v1.PageRequest} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_pagination_pb.PageRequest, 3));
};


/**
 * @param {?proto.nockchain.common.v1.PageRequest|undefined} value
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
*/
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceRequest} returns this
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletGetBalanceRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  BALANCE: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.WalletGetBalanceResponse.ResultCase}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.WalletGetBalanceResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.WalletGetBalanceResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.WalletGetBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.WalletGetBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
balance: (f = msg.getBalance()) && nockchain_common_v2_blockchain_pb.Balance.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.WalletGetBalanceResponse;
  return proto.nockchain.public.v2.WalletGetBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.WalletGetBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v2_blockchain_pb.Balance;
      reader.readMessage(value,nockchain_common_v2_blockchain_pb.Balance.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.WalletGetBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.WalletGetBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v2_blockchain_pb.Balance.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v2.Balance balance = 1;
 * @return {?proto.nockchain.common.v2.Balance}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.getBalance = function() {
  return /** @type{?proto.nockchain.common.v2.Balance} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v2_blockchain_pb.Balance, 1));
};


/**
 * @param {?proto.nockchain.common.v2.Balance|undefined} value
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse} returns this
*/
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.setBalance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.WalletGetBalanceResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse} returns this
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse} returns this
*/
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.WalletGetBalanceResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletGetBalanceResponse} returns this
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletGetBalanceResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.WalletSendTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.WalletSendTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
txId: (f = msg.getTxId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
rawTx: (f = msg.getRawTx()) && nockchain_common_v2_blockchain_pb.RawTransaction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.WalletSendTransactionRequest;
  return proto.nockchain.public.v2.WalletSendTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.WalletSendTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setTxId(value);
      break;
    case 2:
      var value = new nockchain_common_v2_blockchain_pb.RawTransaction;
      reader.readMessage(value,nockchain_common_v2_blockchain_pb.RawTransaction.deserializeBinaryFromReader);
      msg.setRawTx(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.WalletSendTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.WalletSendTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTxId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getRawTx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v2_blockchain_pb.RawTransaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Hash tx_id = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.getTxId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest} returns this
*/
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.setTxId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest} returns this
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.clearTxId = function() {
  return this.setTxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.hasTxId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v2.RawTransaction raw_tx = 2;
 * @return {?proto.nockchain.common.v2.RawTransaction}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.getRawTx = function() {
  return /** @type{?proto.nockchain.common.v2.RawTransaction} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v2_blockchain_pb.RawTransaction, 2));
};


/**
 * @param {?proto.nockchain.common.v2.RawTransaction|undefined} value
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest} returns this
*/
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.setRawTx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionRequest} returns this
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.clearRawTx = function() {
  return this.setRawTx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletSendTransactionRequest.prototype.hasRawTx = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  ACK: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.WalletSendTransactionResponse.ResultCase}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.WalletSendTransactionResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.WalletSendTransactionResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.WalletSendTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.WalletSendTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
ack: (f = msg.getAck()) && nockchain_common_v1_primitives_pb.Acknowledged.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.WalletSendTransactionResponse;
  return proto.nockchain.public.v2.WalletSendTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.WalletSendTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Acknowledged;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Acknowledged.deserializeBinaryFromReader);
      msg.setAck(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.WalletSendTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.WalletSendTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAck();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Acknowledged.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Acknowledged ack = 1;
 * @return {?proto.nockchain.common.v1.Acknowledged}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.getAck = function() {
  return /** @type{?proto.nockchain.common.v1.Acknowledged} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Acknowledged, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Acknowledged|undefined} value
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse} returns this
*/
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.setAck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.WalletSendTransactionResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse} returns this
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.clearAck = function() {
  return this.setAck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.hasAck = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse} returns this
*/
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.WalletSendTransactionResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.WalletSendTransactionResponse} returns this
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.WalletSendTransactionResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionAcceptedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionAcceptedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
txId: (f = msg.getTxId()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedRequest}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionAcceptedRequest;
  return proto.nockchain.public.v2.TransactionAcceptedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionAcceptedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedRequest}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setTxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionAcceptedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionAcceptedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTxId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Hash tx_id = 1;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.getTxId = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionAcceptedRequest} returns this
*/
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.setTxId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedRequest} returns this
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.clearTxId = function() {
  return this.setTxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionAcceptedRequest.prototype.hasTxId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  ACCEPTED: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.TransactionAcceptedResponse.ResultCase}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.TransactionAcceptedResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionAcceptedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionAcceptedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
accepted: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionAcceptedResponse;
  return proto.nockchain.public.v2.TransactionAcceptedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionAcceptedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccepted(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionAcceptedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionAcceptedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool accepted = 1;
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.getAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse} returns this
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.setAccepted = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse} returns this
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.clearAccepted = function() {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.hasAccepted = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse} returns this
*/
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.TransactionAcceptedResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionAcceptedResponse} returns this
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionAcceptedResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetBlocksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetBlocksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetBlocksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlocksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && nockchain_common_v1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetBlocksRequest}
 */
proto.nockchain.public.v2.GetBlocksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetBlocksRequest;
  return proto.nockchain.public.v2.GetBlocksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetBlocksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetBlocksRequest}
 */
proto.nockchain.public.v2.GetBlocksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_pagination_pb.PageRequest;
      reader.readMessage(value,nockchain_common_v1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetBlocksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetBlocksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetBlocksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlocksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.PageRequest page = 1;
 * @return {?proto.nockchain.common.v1.PageRequest}
 */
proto.nockchain.public.v2.GetBlocksRequest.prototype.getPage = function() {
  return /** @type{?proto.nockchain.common.v1.PageRequest} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_pagination_pb.PageRequest, 1));
};


/**
 * @param {?proto.nockchain.common.v1.PageRequest|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlocksRequest} returns this
*/
proto.nockchain.public.v2.GetBlocksRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlocksRequest} returns this
 */
proto.nockchain.public.v2.GetBlocksRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlocksRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetBlocksResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetBlocksResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  BLOCKS: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.GetBlocksResponse.ResultCase}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.GetBlocksResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetBlocksResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetBlocksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetBlocksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlocksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
blocks: (f = msg.getBlocks()) && proto.nockchain.public.v2.BlocksData.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetBlocksResponse}
 */
proto.nockchain.public.v2.GetBlocksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetBlocksResponse;
  return proto.nockchain.public.v2.GetBlocksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetBlocksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetBlocksResponse}
 */
proto.nockchain.public.v2.GetBlocksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.BlocksData;
      reader.readMessage(value,proto.nockchain.public.v2.BlocksData.deserializeBinaryFromReader);
      msg.setBlocks(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetBlocksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetBlocksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlocksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlocks();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.BlocksData.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlocksData blocks = 1;
 * @return {?proto.nockchain.public.v2.BlocksData}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.getBlocks = function() {
  return /** @type{?proto.nockchain.public.v2.BlocksData} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.BlocksData, 1));
};


/**
 * @param {?proto.nockchain.public.v2.BlocksData|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlocksResponse} returns this
*/
proto.nockchain.public.v2.GetBlocksResponse.prototype.setBlocks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.GetBlocksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlocksResponse} returns this
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.clearBlocks = function() {
  return this.setBlocks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.hasBlocks = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlocksResponse} returns this
*/
proto.nockchain.public.v2.GetBlocksResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetBlocksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlocksResponse} returns this
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlocksResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.BlocksData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.BlocksData.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.BlocksData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.BlocksData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlocksData.toObject = function(includeInstance, msg) {
  var f, obj = {
blocksList: jspb.Message.toObjectList(msg.getBlocksList(),
    proto.nockchain.public.v2.BlockEntry.toObject, includeInstance),
currentHeight: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: (f = msg.getPage()) && nockchain_common_v1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.BlocksData}
 */
proto.nockchain.public.v2.BlocksData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.BlocksData;
  return proto.nockchain.public.v2.BlocksData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.BlocksData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.BlocksData}
 */
proto.nockchain.public.v2.BlocksData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.BlockEntry;
      reader.readMessage(value,proto.nockchain.public.v2.BlockEntry.deserializeBinaryFromReader);
      msg.addBlocks(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrentHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_pagination_pb.PageResponse;
      reader.readMessage(value,nockchain_common_v1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.BlocksData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.BlocksData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.BlocksData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlocksData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.public.v2.BlockEntry.serializeBinaryToWriter
    );
  }
  f = message.getCurrentHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BlockEntry blocks = 1;
 * @return {!Array<!proto.nockchain.public.v2.BlockEntry>}
 */
proto.nockchain.public.v2.BlocksData.prototype.getBlocksList = function() {
  return /** @type{!Array<!proto.nockchain.public.v2.BlockEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.public.v2.BlockEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.public.v2.BlockEntry>} value
 * @return {!proto.nockchain.public.v2.BlocksData} returns this
*/
proto.nockchain.public.v2.BlocksData.prototype.setBlocksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.public.v2.BlockEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.public.v2.BlockEntry}
 */
proto.nockchain.public.v2.BlocksData.prototype.addBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.public.v2.BlockEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.BlocksData} returns this
 */
proto.nockchain.public.v2.BlocksData.prototype.clearBlocksList = function() {
  return this.setBlocksList([]);
};


/**
 * optional uint64 current_height = 2;
 * @return {number}
 */
proto.nockchain.public.v2.BlocksData.prototype.getCurrentHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlocksData} returns this
 */
proto.nockchain.public.v2.BlocksData.prototype.setCurrentHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional nockchain.common.v1.PageResponse page = 3;
 * @return {?proto.nockchain.common.v1.PageResponse}
 */
proto.nockchain.public.v2.BlocksData.prototype.getPage = function() {
  return /** @type{?proto.nockchain.common.v1.PageResponse} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_pagination_pb.PageResponse, 3));
};


/**
 * @param {?proto.nockchain.common.v1.PageResponse|undefined} value
 * @return {!proto.nockchain.public.v2.BlocksData} returns this
*/
proto.nockchain.public.v2.BlocksData.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlocksData} returns this
 */
proto.nockchain.public.v2.BlocksData.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlocksData.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.BlockEntry.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.BlockEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.BlockEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.BlockEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlockEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
height: jspb.Message.getFieldWithDefault(msg, 2, 0),
parent: (f = msg.getParent()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
txIdsList: jspb.Message.toObjectList(msg.getTxIdsList(),
    nockchain_common_v1_primitives_pb.Base58Hash.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.BlockEntry}
 */
proto.nockchain.public.v2.BlockEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.BlockEntry;
  return proto.nockchain.public.v2.BlockEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.BlockEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.BlockEntry}
 */
proto.nockchain.public.v2.BlockEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 5:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.addTxIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.BlockEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.BlockEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.BlockEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlockEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getParent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getTxIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Hash block_id = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.BlockEntry.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
*/
proto.nockchain.public.v2.BlockEntry.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
 */
proto.nockchain.public.v2.BlockEntry.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockEntry.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.nockchain.public.v2.BlockEntry.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
 */
proto.nockchain.public.v2.BlockEntry.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional nockchain.common.v1.Hash parent = 3;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.BlockEntry.prototype.getParent = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
*/
proto.nockchain.public.v2.BlockEntry.prototype.setParent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
 */
proto.nockchain.public.v2.BlockEntry.prototype.clearParent = function() {
  return this.setParent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockEntry.prototype.hasParent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */
proto.nockchain.public.v2.BlockEntry.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
 */
proto.nockchain.public.v2.BlockEntry.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated nockchain.common.v1.Base58Hash tx_ids = 5;
 * @return {!Array<!proto.nockchain.common.v1.Base58Hash>}
 */
proto.nockchain.public.v2.BlockEntry.prototype.getTxIdsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Base58Hash>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 5));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Base58Hash>} value
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
*/
proto.nockchain.public.v2.BlockEntry.prototype.setTxIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.nockchain.common.v1.Base58Hash=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.BlockEntry.prototype.addTxIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.nockchain.common.v1.Base58Hash, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.BlockEntry} returns this
 */
proto.nockchain.public.v2.BlockEntry.prototype.clearTxIdsList = function() {
  return this.setTxIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetTransactionBlockRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetTransactionBlockRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
txId: (f = msg.getTxId()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockRequest}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetTransactionBlockRequest;
  return proto.nockchain.public.v2.GetTransactionBlockRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetTransactionBlockRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockRequest}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setTxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetTransactionBlockRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetTransactionBlockRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTxId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Hash tx_id = 1;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.getTxId = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionBlockRequest} returns this
*/
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.setTxId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockRequest} returns this
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.clearTxId = function() {
  return this.setTxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionBlockRequest.prototype.hasTxId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  BLOCK: 1,
  PENDING: 2,
  ERROR: 3
};

/**
 * @return {proto.nockchain.public.v2.GetTransactionBlockResponse.ResultCase}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.GetTransactionBlockResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetTransactionBlockResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetTransactionBlockResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
block: (f = msg.getBlock()) && proto.nockchain.public.v2.TransactionBlockData.toObject(includeInstance, f),
pending: (f = msg.getPending()) && proto.nockchain.public.v2.TransactionPending.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetTransactionBlockResponse;
  return proto.nockchain.public.v2.GetTransactionBlockResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetTransactionBlockResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.TransactionBlockData;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionBlockData.deserializeBinaryFromReader);
      msg.setBlock(value);
      break;
    case 2:
      var value = new proto.nockchain.public.v2.TransactionPending;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionPending.deserializeBinaryFromReader);
      msg.setPending(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetTransactionBlockResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetTransactionBlockResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlock();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.TransactionBlockData.serializeBinaryToWriter
    );
  }
  f = message.getPending();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.public.v2.TransactionPending.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionBlockData block = 1;
 * @return {?proto.nockchain.public.v2.TransactionBlockData}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.getBlock = function() {
  return /** @type{?proto.nockchain.public.v2.TransactionBlockData} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.TransactionBlockData, 1));
};


/**
 * @param {?proto.nockchain.public.v2.TransactionBlockData|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.setBlock = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.clearBlock = function() {
  return this.setBlock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.hasBlock = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TransactionPending pending = 2;
 * @return {?proto.nockchain.public.v2.TransactionPending}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.getPending = function() {
  return /** @type{?proto.nockchain.public.v2.TransactionPending} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.TransactionPending, 2));
};


/**
 * @param {?proto.nockchain.public.v2.TransactionPending|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.setPending = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.clearPending = function() {
  return this.setPending(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.hasPending = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 3;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 3));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.nockchain.public.v2.GetTransactionBlockResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionBlockResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionBlockResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionBlockData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionBlockData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionBlockData.toObject = function(includeInstance, msg) {
  var f, obj = {
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
height: jspb.Message.getFieldWithDefault(msg, 2, 0),
parent: (f = msg.getParent()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionBlockData}
 */
proto.nockchain.public.v2.TransactionBlockData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionBlockData;
  return proto.nockchain.public.v2.TransactionBlockData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionBlockData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionBlockData}
 */
proto.nockchain.public.v2.TransactionBlockData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionBlockData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionBlockData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionBlockData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getParent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional nockchain.common.v1.Hash block_id = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
*/
proto.nockchain.public.v2.TransactionBlockData.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional nockchain.common.v1.Hash parent = 3;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.getParent = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
*/
proto.nockchain.public.v2.TransactionBlockData.prototype.setParent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.clearParent = function() {
  return this.setParent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.hasParent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionBlockData} returns this
 */
proto.nockchain.public.v2.TransactionBlockData.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionPending.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionPending.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionPending} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionPending.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionPending}
 */
proto.nockchain.public.v2.TransactionPending.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionPending;
  return proto.nockchain.public.v2.TransactionPending.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionPending} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionPending}
 */
proto.nockchain.public.v2.TransactionPending.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionPending.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionPending.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionPending} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionPending.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetTransactionDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
txId: (f = msg.getTxId()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsRequest}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetTransactionDetailsRequest;
  return proto.nockchain.public.v2.GetTransactionDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsRequest}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setTxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetTransactionDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTxId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Hash tx_id = 1;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.getTxId = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsRequest} returns this
*/
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.setTxId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsRequest} returns this
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.clearTxId = function() {
  return this.setTxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionDetailsRequest.prototype.hasTxId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  DETAILS: 1,
  PENDING: 2,
  ERROR: 3
};

/**
 * @return {proto.nockchain.public.v2.GetTransactionDetailsResponse.ResultCase}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.GetTransactionDetailsResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetTransactionDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
details: (f = msg.getDetails()) && proto.nockchain.public.v2.TransactionDetails.toObject(includeInstance, f),
pending: (f = msg.getPending()) && proto.nockchain.public.v2.TransactionPending.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetTransactionDetailsResponse;
  return proto.nockchain.public.v2.GetTransactionDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.TransactionDetails;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 2:
      var value = new proto.nockchain.public.v2.TransactionPending;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionPending.deserializeBinaryFromReader);
      msg.setPending(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetTransactionDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetTransactionDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.TransactionDetails.serializeBinaryToWriter
    );
  }
  f = message.getPending();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.public.v2.TransactionPending.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionDetails details = 1;
 * @return {?proto.nockchain.public.v2.TransactionDetails}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.getDetails = function() {
  return /** @type{?proto.nockchain.public.v2.TransactionDetails} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.TransactionDetails, 1));
};


/**
 * @param {?proto.nockchain.public.v2.TransactionDetails|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.setDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TransactionPending pending = 2;
 * @return {?proto.nockchain.public.v2.TransactionPending}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.getPending = function() {
  return /** @type{?proto.nockchain.public.v2.TransactionPending} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.TransactionPending, 2));
};


/**
 * @param {?proto.nockchain.public.v2.TransactionPending|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.setPending = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.clearPending = function() {
  return this.setPending(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.hasPending = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 3;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 3));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
*/
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.nockchain.public.v2.GetTransactionDetailsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetTransactionDetailsResponse} returns this
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetTransactionDetailsResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.TransactionDetails.repeatedFields_ = [10,11];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.TransactionDetails.oneofGroups_ = [[8],[9]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.TransactionDetails.TotalOutputRequiredCase = {
  TOTAL_OUTPUT_REQUIRED_NOT_SET: 0,
  TOTAL_OUTPUT: 8
};

/**
 * @return {proto.nockchain.public.v2.TransactionDetails.TotalOutputRequiredCase}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getTotalOutputRequiredCase = function() {
  return /** @type {proto.nockchain.public.v2.TransactionDetails.TotalOutputRequiredCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.TransactionDetails.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.nockchain.public.v2.TransactionDetails.FeeRequiredCase = {
  FEE_REQUIRED_NOT_SET: 0,
  FEE: 9
};

/**
 * @return {proto.nockchain.public.v2.TransactionDetails.FeeRequiredCase}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getFeeRequiredCase = function() {
  return /** @type {proto.nockchain.public.v2.TransactionDetails.FeeRequiredCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.TransactionDetails.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
txId: jspb.Message.getFieldWithDefault(msg, 1, ""),
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
height: jspb.Message.getFieldWithDefault(msg, 3, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
version: jspb.Message.getFieldWithDefault(msg, 5, 0),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalInput: (f = msg.getTotalInput()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
totalOutput: (f = msg.getTotalOutput()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
fee: (f = msg.getFee()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
inputsList: jspb.Message.toObjectList(msg.getInputsList(),
    proto.nockchain.public.v2.TransactionInput.toObject, includeInstance),
outputsList: jspb.Message.toObjectList(msg.getOutputsList(),
    proto.nockchain.public.v2.TransactionOutput.toObject, includeInstance),
parent: (f = msg.getParent()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionDetails}
 */
proto.nockchain.public.v2.TransactionDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionDetails;
  return proto.nockchain.public.v2.TransactionDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionDetails}
 */
proto.nockchain.public.v2.TransactionDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTxId(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVersion(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSizeBytes(value);
      break;
    case 7:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setTotalInput(value);
      break;
    case 8:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setTotalOutput(value);
      break;
    case 9:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setFee(value);
      break;
    case 10:
      var value = new proto.nockchain.public.v2.TransactionInput;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionInput.deserializeBinaryFromReader);
      msg.addInputs(value);
      break;
    case 11:
      var value = new proto.nockchain.public.v2.TransactionOutput;
      reader.readMessage(value,proto.nockchain.public.v2.TransactionOutput.deserializeBinaryFromReader);
      msg.addOutputs(value);
      break;
    case 12:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTxId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getTotalInput();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getTotalOutput();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getFee();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getInputsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.nockchain.public.v2.TransactionInput.serializeBinaryToWriter
    );
  }
  f = message.getOutputsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.nockchain.public.v2.TransactionOutput.serializeBinaryToWriter
    );
  }
  f = message.getParent();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tx_id = 1;
 * @return {string}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getTxId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.setTxId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional nockchain.common.v1.Hash block_id = 2;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 height = 3;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 version = 5;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 size_bytes = 6;
 * @return {number}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional nockchain.common.v1.Nicks total_input = 7;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getTotalInput = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 7));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setTotalInput = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearTotalInput = function() {
  return this.setTotalInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.hasTotalInput = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional nockchain.common.v1.Nicks total_output = 8;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getTotalOutput = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 8));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setTotalOutput = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.nockchain.public.v2.TransactionDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearTotalOutput = function() {
  return this.setTotalOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.hasTotalOutput = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional nockchain.common.v1.Nicks fee = 9;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getFee = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 9));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setFee = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.nockchain.public.v2.TransactionDetails.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearFee = function() {
  return this.setFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.hasFee = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated TransactionInput inputs = 10;
 * @return {!Array<!proto.nockchain.public.v2.TransactionInput>}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getInputsList = function() {
  return /** @type{!Array<!proto.nockchain.public.v2.TransactionInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.public.v2.TransactionInput, 10));
};


/**
 * @param {!Array<!proto.nockchain.public.v2.TransactionInput>} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setInputsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.nockchain.public.v2.TransactionInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.public.v2.TransactionInput}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.addInputs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.nockchain.public.v2.TransactionInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearInputsList = function() {
  return this.setInputsList([]);
};


/**
 * repeated TransactionOutput outputs = 11;
 * @return {!Array<!proto.nockchain.public.v2.TransactionOutput>}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getOutputsList = function() {
  return /** @type{!Array<!proto.nockchain.public.v2.TransactionOutput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.public.v2.TransactionOutput, 11));
};


/**
 * @param {!Array<!proto.nockchain.public.v2.TransactionOutput>} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setOutputsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.nockchain.public.v2.TransactionOutput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.public.v2.TransactionOutput}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.addOutputs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.nockchain.public.v2.TransactionOutput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearOutputsList = function() {
  return this.setOutputsList([]);
};


/**
 * optional nockchain.common.v1.Hash parent = 12;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.getParent = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 12));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
*/
proto.nockchain.public.v2.TransactionDetails.prototype.setParent = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionDetails} returns this
 */
proto.nockchain.public.v2.TransactionDetails.prototype.clearParent = function() {
  return this.setParent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionDetails.prototype.hasParent = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionInput.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionInput.toObject = function(includeInstance, msg) {
  var f, obj = {
noteNameB58: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: (f = msg.getAmount()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
sourceTxId: jspb.Message.getFieldWithDefault(msg, 3, ""),
coinbase: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionInput}
 */
proto.nockchain.public.v2.TransactionInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionInput;
  return proto.nockchain.public.v2.TransactionInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionInput}
 */
proto.nockchain.public.v2.TransactionInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoteNameB58(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceTxId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoinbase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteNameB58();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getSourceTxId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCoinbase();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string note_name_b58 = 1;
 * @return {string}
 */
proto.nockchain.public.v2.TransactionInput.prototype.getNoteNameB58 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.TransactionInput} returns this
 */
proto.nockchain.public.v2.TransactionInput.prototype.setNoteNameB58 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional nockchain.common.v1.Nicks amount = 2;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.TransactionInput.prototype.getAmount = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionInput} returns this
*/
proto.nockchain.public.v2.TransactionInput.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionInput} returns this
 */
proto.nockchain.public.v2.TransactionInput.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionInput.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string source_tx_id = 3;
 * @return {string}
 */
proto.nockchain.public.v2.TransactionInput.prototype.getSourceTxId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.TransactionInput} returns this
 */
proto.nockchain.public.v2.TransactionInput.prototype.setSourceTxId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool coinbase = 4;
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionInput.prototype.getCoinbase = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.public.v2.TransactionInput} returns this
 */
proto.nockchain.public.v2.TransactionInput.prototype.setCoinbase = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.TransactionOutput.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.TransactionOutput.AmountRequiredCase = {
  AMOUNT_REQUIRED_NOT_SET: 0,
  AMOUNT: 2
};

/**
 * @return {proto.nockchain.public.v2.TransactionOutput.AmountRequiredCase}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.getAmountRequiredCase = function() {
  return /** @type {proto.nockchain.public.v2.TransactionOutput.AmountRequiredCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.TransactionOutput.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.TransactionOutput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.TransactionOutput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionOutput.toObject = function(includeInstance, msg) {
  var f, obj = {
noteNameB58: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: (f = msg.getAmount()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
lockSummary: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.TransactionOutput}
 */
proto.nockchain.public.v2.TransactionOutput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.TransactionOutput;
  return proto.nockchain.public.v2.TransactionOutput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.TransactionOutput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.TransactionOutput}
 */
proto.nockchain.public.v2.TransactionOutput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoteNameB58(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.TransactionOutput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.TransactionOutput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.TransactionOutput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteNameB58();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getLockSummary();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string note_name_b58 = 1;
 * @return {string}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.getNoteNameB58 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.TransactionOutput} returns this
 */
proto.nockchain.public.v2.TransactionOutput.prototype.setNoteNameB58 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional nockchain.common.v1.Nicks amount = 2;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.getAmount = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.TransactionOutput} returns this
*/
proto.nockchain.public.v2.TransactionOutput.prototype.setAmount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.TransactionOutput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.TransactionOutput} returns this
 */
proto.nockchain.public.v2.TransactionOutput.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string lock_summary = 3;
 * @return {string}
 */
proto.nockchain.public.v2.TransactionOutput.prototype.getLockSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.TransactionOutput} returns this
 */
proto.nockchain.public.v2.TransactionOutput.prototype.setLockSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.SelectorCase = {
  SELECTOR_NOT_SET: 0,
  HEIGHT: 1,
  BLOCK_ID: 2
};

/**
 * @return {proto.nockchain.public.v2.GetBlockDetailsRequest.SelectorCase}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.getSelectorCase = function() {
  return /** @type {proto.nockchain.public.v2.GetBlockDetailsRequest.SelectorCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetBlockDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetBlockDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
height: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetBlockDetailsRequest;
  return proto.nockchain.public.v2.GetBlockDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetBlockDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetBlockDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetBlockDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 height = 1;
 * @return {number}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest} returns this
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.setHeight = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest} returns this
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.clearHeight = function() {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Base58Hash block_id = 2;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest} returns this
*/
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.setBlockId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetBlockDetailsRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsRequest} returns this
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlockDetailsRequest.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  DETAILS: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.GetBlockDetailsResponse.ResultCase}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.GetBlockDetailsResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetBlockDetailsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetBlockDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetBlockDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
details: (f = msg.getDetails()) && proto.nockchain.public.v2.BlockDetails.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetBlockDetailsResponse;
  return proto.nockchain.public.v2.GetBlockDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetBlockDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.BlockDetails;
      reader.readMessage(value,proto.nockchain.public.v2.BlockDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetBlockDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetBlockDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.BlockDetails.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlockDetails details = 1;
 * @return {?proto.nockchain.public.v2.BlockDetails}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.getDetails = function() {
  return /** @type{?proto.nockchain.public.v2.BlockDetails} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.BlockDetails, 1));
};


/**
 * @param {?proto.nockchain.public.v2.BlockDetails|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse} returns this
*/
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.setDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.GetBlockDetailsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse} returns this
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse} returns this
*/
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetBlockDetailsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetBlockDetailsResponse} returns this
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetBlockDetailsResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetExplorerMetricsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsRequest}
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetExplorerMetricsRequest;
  return proto.nockchain.public.v2.GetExplorerMetricsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsRequest}
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetExplorerMetricsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetExplorerMetricsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  METRICS: 1,
  ERROR: 2
};

/**
 * @return {proto.nockchain.public.v2.GetExplorerMetricsResponse.ResultCase}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.getResultCase = function() {
  return /** @type {proto.nockchain.public.v2.GetExplorerMetricsResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.GetExplorerMetricsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.GetExplorerMetricsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metrics: (f = msg.getMetrics()) && proto.nockchain.public.v2.ExplorerMetrics.toObject(includeInstance, f),
error: (f = msg.getError()) && nockchain_common_v1_primitives_pb.ErrorStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.GetExplorerMetricsResponse;
  return proto.nockchain.public.v2.GetExplorerMetricsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.ExplorerMetrics;
      reader.readMessage(value,proto.nockchain.public.v2.ExplorerMetrics.deserializeBinaryFromReader);
      msg.setMetrics(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.ErrorStatus;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.ErrorStatus.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.GetExplorerMetricsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.GetExplorerMetricsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetrics();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.ExplorerMetrics.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.ErrorStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExplorerMetrics metrics = 1;
 * @return {?proto.nockchain.public.v2.ExplorerMetrics}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.getMetrics = function() {
  return /** @type{?proto.nockchain.public.v2.ExplorerMetrics} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.ExplorerMetrics, 1));
};


/**
 * @param {?proto.nockchain.public.v2.ExplorerMetrics|undefined} value
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse} returns this
*/
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.setMetrics = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.GetExplorerMetricsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse} returns this
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.clearMetrics = function() {
  return this.setMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.hasMetrics = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.ErrorStatus error = 2;
 * @return {?proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.getError = function() {
  return /** @type{?proto.nockchain.common.v1.ErrorStatus} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.ErrorStatus, 2));
};


/**
 * @param {?proto.nockchain.common.v1.ErrorStatus|undefined} value
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse} returns this
*/
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.GetExplorerMetricsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.GetExplorerMetricsResponse} returns this
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.GetExplorerMetricsResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.ExplorerMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.ExplorerMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.ExplorerMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
cacheHeight: jspb.Message.getFieldWithDefault(msg, 1, 0),
heaviestHeight: jspb.Message.getFieldWithDefault(msg, 2, 0),
cacheLowestHeight: jspb.Message.getFieldWithDefault(msg, 3, 0),
cacheSpan: jspb.Message.getFieldWithDefault(msg, 4, 0),
cacheCoverageRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
refreshAgeSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
backfillAgeSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
seedReady: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
seedTimeSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
backfillResumeHeight: jspb.Message.getFieldWithDefault(msg, 10, 0),
cacheAgeSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
refreshSuccessCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
refreshErrorCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
backfillSuccessCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
backfillErrorCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
getBlocksP50Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
getBlocksP90Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
getBlocksP99Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
getBlockDetailsP50Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
getBlockDetailsP90Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
getBlockDetailsP99Ms: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.ExplorerMetrics}
 */
proto.nockchain.public.v2.ExplorerMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.ExplorerMetrics;
  return proto.nockchain.public.v2.ExplorerMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.ExplorerMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.ExplorerMetrics}
 */
proto.nockchain.public.v2.ExplorerMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCacheHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeaviestHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCacheLowestHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCacheSpan(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCacheCoverageRatio(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRefreshAgeSeconds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBackfillAgeSeconds(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSeedReady(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeedTimeSeconds(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBackfillResumeHeight(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCacheAgeSeconds(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRefreshSuccessCount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRefreshErrorCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBackfillSuccessCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBackfillErrorCount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlocksP50Ms(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlocksP90Ms(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlocksP99Ms(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlockDetailsP50Ms(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlockDetailsP90Ms(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGetBlockDetailsP99Ms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.ExplorerMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.ExplorerMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.ExplorerMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCacheHeight();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHeaviestHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getCacheLowestHeight();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getCacheSpan();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getCacheCoverageRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getRefreshAgeSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getBackfillAgeSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getSeedReady();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSeedTimeSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getBackfillResumeHeight();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCacheAgeSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getRefreshSuccessCount();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getRefreshErrorCount();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getBackfillSuccessCount();
  if (f !== 0) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = message.getBackfillErrorCount();
  if (f !== 0) {
    writer.writeUint64(
      15,
      f
    );
  }
  f = message.getGetBlocksP50Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getGetBlocksP90Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getGetBlocksP99Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getGetBlockDetailsP50Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getGetBlockDetailsP90Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getGetBlockDetailsP99Ms();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
};


/**
 * optional uint64 cache_height = 1;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getCacheHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setCacheHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 heaviest_height = 2;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getHeaviestHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setHeaviestHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 cache_lowest_height = 3;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getCacheLowestHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setCacheLowestHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 cache_span = 4;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getCacheSpan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setCacheSpan = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double cache_coverage_ratio = 5;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getCacheCoverageRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setCacheCoverageRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double refresh_age_seconds = 6;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getRefreshAgeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setRefreshAgeSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double backfill_age_seconds = 7;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getBackfillAgeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setBackfillAgeSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional bool seed_ready = 8;
 * @return {boolean}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getSeedReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setSeedReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional double seed_time_seconds = 9;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getSeedTimeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setSeedTimeSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional int64 backfill_resume_height = 10;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getBackfillResumeHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setBackfillResumeHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double cache_age_seconds = 11;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getCacheAgeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setCacheAgeSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional uint64 refresh_success_count = 12;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getRefreshSuccessCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setRefreshSuccessCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint64 refresh_error_count = 13;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getRefreshErrorCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setRefreshErrorCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional uint64 backfill_success_count = 14;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getBackfillSuccessCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setBackfillSuccessCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint64 backfill_error_count = 15;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getBackfillErrorCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setBackfillErrorCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double get_blocks_p50_ms = 16;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlocksP50Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlocksP50Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double get_blocks_p90_ms = 17;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlocksP90Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlocksP90Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double get_blocks_p99_ms = 18;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlocksP99Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlocksP99Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional double get_block_details_p50_ms = 19;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlockDetailsP50Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlockDetailsP50Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double get_block_details_p90_ms = 20;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlockDetailsP90Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlockDetailsP90Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional double get_block_details_p99_ms = 21;
 * @return {number}
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.getGetBlockDetailsP99Ms = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.ExplorerMetrics} returns this
 */
proto.nockchain.public.v2.ExplorerMetrics.prototype.setGetBlockDetailsP99Ms = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.BlockDetails.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.BlockDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.BlockDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.BlockDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlockDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
height: jspb.Message.getFieldWithDefault(msg, 2, 0),
parent: (f = msg.getParent()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
pow: (f = msg.getPow()) && proto.nockchain.public.v2.ProofOfWork.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
epochCounter: jspb.Message.getFieldWithDefault(msg, 6, 0),
target: (f = msg.getTarget()) && proto.nockchain.public.v2.BigNum.toObject(includeInstance, f),
accumulatedWork: (f = msg.getAccumulatedWork()) && proto.nockchain.public.v2.BigNum.toObject(includeInstance, f),
txIdsList: jspb.Message.toObjectList(msg.getTxIdsList(),
    nockchain_common_v1_primitives_pb.Base58Hash.toObject, includeInstance),
coinbase: (f = msg.getCoinbase()) && proto.nockchain.public.v2.CoinbaseSplit.toObject(includeInstance, f),
msg: (f = msg.getMsg()) && proto.nockchain.public.v2.PageMsg.toObject(includeInstance, f),
txCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
hasPow: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
version: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.BlockDetails}
 */
proto.nockchain.public.v2.BlockDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.BlockDetails;
  return proto.nockchain.public.v2.BlockDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.BlockDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.BlockDetails}
 */
proto.nockchain.public.v2.BlockDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParent(value);
      break;
    case 4:
      var value = new proto.nockchain.public.v2.ProofOfWork;
      reader.readMessage(value,proto.nockchain.public.v2.ProofOfWork.deserializeBinaryFromReader);
      msg.setPow(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEpochCounter(value);
      break;
    case 7:
      var value = new proto.nockchain.public.v2.BigNum;
      reader.readMessage(value,proto.nockchain.public.v2.BigNum.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    case 8:
      var value = new proto.nockchain.public.v2.BigNum;
      reader.readMessage(value,proto.nockchain.public.v2.BigNum.deserializeBinaryFromReader);
      msg.setAccumulatedWork(value);
      break;
    case 9:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.addTxIds(value);
      break;
    case 10:
      var value = new proto.nockchain.public.v2.CoinbaseSplit;
      reader.readMessage(value,proto.nockchain.public.v2.CoinbaseSplit.deserializeBinaryFromReader);
      msg.setCoinbase(value);
      break;
    case 11:
      var value = new proto.nockchain.public.v2.PageMsg;
      reader.readMessage(value,proto.nockchain.public.v2.PageMsg.deserializeBinaryFromReader);
      msg.setMsg(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxCount(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPow(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.BlockDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.BlockDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.BlockDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BlockDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getParent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getPow();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.public.v2.ProofOfWork.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getEpochCounter();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.nockchain.public.v2.BigNum.serializeBinaryToWriter
    );
  }
  f = message.getAccumulatedWork();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.nockchain.public.v2.BigNum.serializeBinaryToWriter
    );
  }
  f = message.getTxIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
  f = message.getCoinbase();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.nockchain.public.v2.CoinbaseSplit.serializeBinaryToWriter
    );
  }
  f = message.getMsg();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.nockchain.public.v2.PageMsg.serializeBinaryToWriter
    );
  }
  f = message.getTxCount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getHasPow();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
};


/**
 * optional nockchain.common.v1.Hash block_id = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 height = 2;
 * @return {number}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional nockchain.common.v1.Hash parent = 3;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getParent = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setParent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearParent = function() {
  return this.setParent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasParent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProofOfWork pow = 4;
 * @return {?proto.nockchain.public.v2.ProofOfWork}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getPow = function() {
  return /** @type{?proto.nockchain.public.v2.ProofOfWork} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.ProofOfWork, 4));
};


/**
 * @param {?proto.nockchain.public.v2.ProofOfWork|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setPow = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearPow = function() {
  return this.setPow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasPow = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 timestamp = 5;
 * @return {number}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 epoch_counter = 6;
 * @return {number}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getEpochCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setEpochCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional BigNum target = 7;
 * @return {?proto.nockchain.public.v2.BigNum}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getTarget = function() {
  return /** @type{?proto.nockchain.public.v2.BigNum} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.BigNum, 7));
};


/**
 * @param {?proto.nockchain.public.v2.BigNum|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setTarget = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearTarget = function() {
  return this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional BigNum accumulated_work = 8;
 * @return {?proto.nockchain.public.v2.BigNum}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getAccumulatedWork = function() {
  return /** @type{?proto.nockchain.public.v2.BigNum} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.BigNum, 8));
};


/**
 * @param {?proto.nockchain.public.v2.BigNum|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setAccumulatedWork = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearAccumulatedWork = function() {
  return this.setAccumulatedWork(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasAccumulatedWork = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated nockchain.common.v1.Base58Hash tx_ids = 9;
 * @return {!Array<!proto.nockchain.common.v1.Base58Hash>}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getTxIdsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Base58Hash>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 9));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Base58Hash>} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setTxIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.nockchain.common.v1.Base58Hash=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.BlockDetails.prototype.addTxIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.nockchain.common.v1.Base58Hash, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearTxIdsList = function() {
  return this.setTxIdsList([]);
};


/**
 * optional CoinbaseSplit coinbase = 10;
 * @return {?proto.nockchain.public.v2.CoinbaseSplit}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getCoinbase = function() {
  return /** @type{?proto.nockchain.public.v2.CoinbaseSplit} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.CoinbaseSplit, 10));
};


/**
 * @param {?proto.nockchain.public.v2.CoinbaseSplit|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setCoinbase = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearCoinbase = function() {
  return this.setCoinbase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasCoinbase = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PageMsg msg = 11;
 * @return {?proto.nockchain.public.v2.PageMsg}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getMsg = function() {
  return /** @type{?proto.nockchain.public.v2.PageMsg} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.PageMsg, 11));
};


/**
 * @param {?proto.nockchain.public.v2.PageMsg|undefined} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
*/
proto.nockchain.public.v2.BlockDetails.prototype.setMsg = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.clearMsg = function() {
  return this.setMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.hasMsg = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional uint32 tx_count = 12;
 * @return {number}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getTxCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setTxCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool has_pow = 13;
 * @return {boolean}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getHasPow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setHasPow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional uint32 version = 14;
 * @return {number}
 */
proto.nockchain.public.v2.BlockDetails.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.BlockDetails} returns this
 */
proto.nockchain.public.v2.BlockDetails.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.ProofOfWork.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.ProofOfWork} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.ProofOfWork.toObject = function(includeInstance, msg) {
  var f, obj = {
present: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
rawProof: msg.getRawProof_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.ProofOfWork}
 */
proto.nockchain.public.v2.ProofOfWork.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.ProofOfWork;
  return proto.nockchain.public.v2.ProofOfWork.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.ProofOfWork} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.ProofOfWork}
 */
proto.nockchain.public.v2.ProofOfWork.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPresent(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setRawProof(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.ProofOfWork.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.ProofOfWork} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.ProofOfWork.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPresent();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bool present = 1;
 * @return {boolean}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.getPresent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.public.v2.ProofOfWork} returns this
 */
proto.nockchain.public.v2.ProofOfWork.prototype.setPresent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bytes raw_proof = 2;
 * @return {!(string|Uint8Array)}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.getRawProof = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes raw_proof = 2;
 * This is a type-conversion wrapper around `getRawProof()`
 * @return {string}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.getRawProof_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getRawProof()));
};


/**
 * optional bytes raw_proof = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRawProof()`
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.getRawProof_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getRawProof()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.nockchain.public.v2.ProofOfWork} returns this
 */
proto.nockchain.public.v2.ProofOfWork.prototype.setRawProof = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.public.v2.ProofOfWork} returns this
 */
proto.nockchain.public.v2.ProofOfWork.prototype.clearRawProof = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.ProofOfWork.prototype.hasRawProof = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.BigNum.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.BigNum.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.BigNum} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BigNum.toObject = function(includeInstance, msg) {
  var f, obj = {
display: jspb.Message.getFieldWithDefault(msg, 1, ""),
rawBytes: msg.getRawBytes_asB64(),
hex: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.BigNum}
 */
proto.nockchain.public.v2.BigNum.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.BigNum;
  return proto.nockchain.public.v2.BigNum.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.BigNum} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.BigNum}
 */
proto.nockchain.public.v2.BigNum.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplay(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setRawBytes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.BigNum.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.BigNum.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.BigNum} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.BigNum.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplay();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRawBytes_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getHex();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string display = 1;
 * @return {string}
 */
proto.nockchain.public.v2.BigNum.prototype.getDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.BigNum} returns this
 */
proto.nockchain.public.v2.BigNum.prototype.setDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes raw_bytes = 2;
 * @return {!(string|Uint8Array)}
 */
proto.nockchain.public.v2.BigNum.prototype.getRawBytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes raw_bytes = 2;
 * This is a type-conversion wrapper around `getRawBytes()`
 * @return {string}
 */
proto.nockchain.public.v2.BigNum.prototype.getRawBytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getRawBytes()));
};


/**
 * optional bytes raw_bytes = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRawBytes()`
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.BigNum.prototype.getRawBytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getRawBytes()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.nockchain.public.v2.BigNum} returns this
 */
proto.nockchain.public.v2.BigNum.prototype.setRawBytes = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional string hex = 3;
 * @return {string}
 */
proto.nockchain.public.v2.BigNum.prototype.getHex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.BigNum} returns this
 */
proto.nockchain.public.v2.BigNum.prototype.setHex = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.public.v2.CoinbaseSplit.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.public.v2.CoinbaseSplit.VersionCase = {
  VERSION_NOT_SET: 0,
  V0: 1,
  V1: 2
};

/**
 * @return {proto.nockchain.public.v2.CoinbaseSplit.VersionCase}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.getVersionCase = function() {
  return /** @type {proto.nockchain.public.v2.CoinbaseSplit.VersionCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.public.v2.CoinbaseSplit.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.CoinbaseSplit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.CoinbaseSplit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplit.toObject = function(includeInstance, msg) {
  var f, obj = {
v0: (f = msg.getV0()) && proto.nockchain.public.v2.CoinbaseSplitV0.toObject(includeInstance, f),
v1: (f = msg.getV1()) && proto.nockchain.public.v2.CoinbaseSplitV1.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.CoinbaseSplit}
 */
proto.nockchain.public.v2.CoinbaseSplit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.CoinbaseSplit;
  return proto.nockchain.public.v2.CoinbaseSplit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.CoinbaseSplit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.CoinbaseSplit}
 */
proto.nockchain.public.v2.CoinbaseSplit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.CoinbaseSplitV0;
      reader.readMessage(value,proto.nockchain.public.v2.CoinbaseSplitV0.deserializeBinaryFromReader);
      msg.setV0(value);
      break;
    case 2:
      var value = new proto.nockchain.public.v2.CoinbaseSplitV1;
      reader.readMessage(value,proto.nockchain.public.v2.CoinbaseSplitV1.deserializeBinaryFromReader);
      msg.setV1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.CoinbaseSplit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.CoinbaseSplit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getV0();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.public.v2.CoinbaseSplitV0.serializeBinaryToWriter
    );
  }
  f = message.getV1();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.public.v2.CoinbaseSplitV1.serializeBinaryToWriter
    );
  }
};


/**
 * optional CoinbaseSplitV0 v0 = 1;
 * @return {?proto.nockchain.public.v2.CoinbaseSplitV0}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.getV0 = function() {
  return /** @type{?proto.nockchain.public.v2.CoinbaseSplitV0} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.CoinbaseSplitV0, 1));
};


/**
 * @param {?proto.nockchain.public.v2.CoinbaseSplitV0|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplit} returns this
*/
proto.nockchain.public.v2.CoinbaseSplit.prototype.setV0 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.public.v2.CoinbaseSplit.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplit} returns this
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.clearV0 = function() {
  return this.setV0(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.hasV0 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CoinbaseSplitV1 v1 = 2;
 * @return {?proto.nockchain.public.v2.CoinbaseSplitV1}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.getV1 = function() {
  return /** @type{?proto.nockchain.public.v2.CoinbaseSplitV1} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.public.v2.CoinbaseSplitV1, 2));
};


/**
 * @param {?proto.nockchain.public.v2.CoinbaseSplitV1|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplit} returns this
*/
proto.nockchain.public.v2.CoinbaseSplit.prototype.setV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.public.v2.CoinbaseSplit.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplit} returns this
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.clearV1 = function() {
  return this.setV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplit.prototype.hasV1 = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.CoinbaseSplitV0.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.CoinbaseSplitV0.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV0.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.nockchain.public.v2.CoinbaseSplitV0Entry.toObject, includeInstance),
entryCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
note: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.CoinbaseSplitV0;
  return proto.nockchain.public.v2.CoinbaseSplitV0.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.CoinbaseSplitV0Entry;
      reader.readMessage(value,proto.nockchain.public.v2.CoinbaseSplitV0Entry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEntryCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.CoinbaseSplitV0.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV0.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.public.v2.CoinbaseSplitV0Entry.serializeBinaryToWriter
    );
  }
  f = message.getEntryCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated CoinbaseSplitV0Entry entries = 1;
 * @return {!Array<!proto.nockchain.public.v2.CoinbaseSplitV0Entry>}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.nockchain.public.v2.CoinbaseSplitV0Entry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.public.v2.CoinbaseSplitV0Entry, 1));
};


/**
 * @param {!Array<!proto.nockchain.public.v2.CoinbaseSplitV0Entry>} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0Entry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.public.v2.CoinbaseSplitV0Entry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional uint32 entry_count = 2;
 * @return {number}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.getEntryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.setEntryCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string note = 3;
 * @return {string}
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV0.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.CoinbaseSplitV0Entry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.toObject = function(includeInstance, msg) {
  var f, obj = {
pubkey: (f = msg.getPubkey()) && nockchain_common_v1_primitives_pb.Base58Pubkey.toObject(includeInstance, f),
amount: (f = msg.getAmount()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.CoinbaseSplitV0Entry;
  return proto.nockchain.public.v2.CoinbaseSplitV0Entry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Pubkey;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Pubkey.deserializeBinaryFromReader);
      msg.setPubkey(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.CoinbaseSplitV0Entry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPubkey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Pubkey.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Pubkey pubkey = 1;
 * @return {?proto.nockchain.common.v1.Base58Pubkey}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.getPubkey = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Pubkey} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Pubkey, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Pubkey|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.setPubkey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.clearPubkey = function() {
  return this.setPubkey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.hasPubkey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Nicks amount = 2;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.getAmount = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV0Entry} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplitV0Entry.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.public.v2.CoinbaseSplitV1.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.CoinbaseSplitV1.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV1.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.nockchain.public.v2.CoinbaseSplitV1Entry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.CoinbaseSplitV1;
  return proto.nockchain.public.v2.CoinbaseSplitV1.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.public.v2.CoinbaseSplitV1Entry;
      reader.readMessage(value,proto.nockchain.public.v2.CoinbaseSplitV1Entry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.CoinbaseSplitV1.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV1.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.public.v2.CoinbaseSplitV1Entry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CoinbaseSplitV1Entry entries = 1;
 * @return {!Array<!proto.nockchain.public.v2.CoinbaseSplitV1Entry>}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.nockchain.public.v2.CoinbaseSplitV1Entry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.public.v2.CoinbaseSplitV1Entry, 1));
};


/**
 * @param {!Array<!proto.nockchain.public.v2.CoinbaseSplitV1Entry>} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1Entry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.public.v2.CoinbaseSplitV1Entry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV1.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.CoinbaseSplitV1Entry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.toObject = function(includeInstance, msg) {
  var f, obj = {
lockHash: (f = msg.getLockHash()) && nockchain_common_v1_primitives_pb.Base58Hash.toObject(includeInstance, f),
amount: (f = msg.getAmount()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.CoinbaseSplitV1Entry;
  return proto.nockchain.public.v2.CoinbaseSplitV1Entry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Base58Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Base58Hash.deserializeBinaryFromReader);
      msg.setLockHash(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.CoinbaseSplitV1Entry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLockHash();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Base58Hash.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Base58Hash lock_hash = 1;
 * @return {?proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.getLockHash = function() {
  return /** @type{?proto.nockchain.common.v1.Base58Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Base58Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Base58Hash|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.setLockHash = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.clearLockHash = function() {
  return this.setLockHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.hasLockHash = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Nicks amount = 2;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.getAmount = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} returns this
*/
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.public.v2.CoinbaseSplitV1Entry} returns this
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.public.v2.CoinbaseSplitV1Entry.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.public.v2.PageMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.public.v2.PageMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.public.v2.PageMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.PageMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
raw: msg.getRaw_asB64(),
decoded: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.public.v2.PageMsg}
 */
proto.nockchain.public.v2.PageMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.public.v2.PageMsg;
  return proto.nockchain.public.v2.PageMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.public.v2.PageMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.public.v2.PageMsg}
 */
proto.nockchain.public.v2.PageMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setRaw(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDecoded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.PageMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.public.v2.PageMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.public.v2.PageMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.public.v2.PageMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaw_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getDecoded();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bytes raw = 1;
 * @return {!(string|Uint8Array)}
 */
proto.nockchain.public.v2.PageMsg.prototype.getRaw = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes raw = 1;
 * This is a type-conversion wrapper around `getRaw()`
 * @return {string}
 */
proto.nockchain.public.v2.PageMsg.prototype.getRaw_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getRaw()));
};


/**
 * optional bytes raw = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRaw()`
 * @return {!Uint8Array}
 */
proto.nockchain.public.v2.PageMsg.prototype.getRaw_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getRaw()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.nockchain.public.v2.PageMsg} returns this
 */
proto.nockchain.public.v2.PageMsg.prototype.setRaw = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string decoded = 2;
 * @return {string}
 */
proto.nockchain.public.v2.PageMsg.prototype.getDecoded = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.public.v2.PageMsg} returns this
 */
proto.nockchain.public.v2.PageMsg.prototype.setDecoded = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.nockchain.public.v2);
